import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// An admin token is only valid for 12 hours. When it expires the server replies 401.
// Clear the dead session and send the user back to the login screen, instead of
// letting the rejected request bubble up as an uncaught runtime error.
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const url = error?.config?.url || "";
        const isAdminCall = url.startsWith("/admin") && !url.startsWith("/admin/login");
        if (status === 401 && isAdminCall) {
            localStorage.removeItem("Kanganya_admin_token");
            if (!window.location.pathname.startsWith("/admin/login")) {
                window.location.assign("/admin/login");
            }
        }
        return Promise.reject(error);
    }
);

export const fetchProducts = async (params = {}) => {
    const { data } = await api.get("/products", { params });
    return data;
};

export const fetchProduct = async (id) => {
    const { data } = await api.get(`/products/${id}`);
    return data;
};

export const createOrder = async (payload, headers = {}) => {
    const { data } = await api.post("/orders", payload, { headers });
    return data;
};

export const trackShipment = async (trackingId) => {
    const { data } = await api.get(`/track-shipment/${encodeURIComponent(trackingId)}`);
    return data;
};

export const trackOrder = async (orderNumber) => {
    const { data } = await api.get(`/orders/${orderNumber}`);
    return data;
};

export const fetchMyOrders = async (headers) => {
    const { data } = await api.get("/my-orders", { headers });
    return data;
};

export const cancelOrder = async (orderNumber, email, reason, note = "") => {
    const { data } = await api.post(`/orders/${orderNumber}/cancel`, { email, reason, note });
    return data;
};

export const requestReturnOrRefund = async (orderNumber, { type, email, reason, note = "", video = null }, headers = {}) => {
    const { data } = await api.post(`/orders/${orderNumber}/return-request`, { type, email, reason, note, video }, { headers });
    return data;
};

export const uploadReturnMedia = async (file, headers) => {
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await api.post("/uploads/return-media", formData, {
        headers: { ...headers, "Content-Type": "multipart/form-data" },
    });
    return data;
};

export const fetchProductReviews = async (productId) => {
    const { data } = await api.get(`/products/${productId}/reviews`);
    return data;
};

export const createProductReview = async (productId, payload, headers) => {
    const { data } = await api.post(`/products/${productId}/reviews`, payload, { headers });
    return data;
};

export const uploadReviewMedia = async (file, headers) => {
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await api.post("/uploads/review-media", formData, {
        headers: { ...headers, "Content-Type": "multipart/form-data" },
    });
    return data;
};

export const subscribeNewsletter = async (email) => {
    const { data } = await api.post("/newsletter", { email });
    return data;
};

export const validateCoupon = async (code, email = "") => {
    const { data } = await api.get(`/coupons/validate/${encodeURIComponent(code)}`, { params: email ? { email } : {} });
    return data;
};

export const fetchPaymentConfig = async () => {
    const { data } = await api.get("/payments/config");
    return data;
};

export const initiatePayment = async (orderNumber, email) => {
    const { data } = await api.post("/payments/initiate", { order_number: orderNumber, email });
    return data;
};

export const verifyPayment = async (orderNumber, email, gatewayData = {}) => {
    const { data } = await api.post("/payments/verify", { order_number: orderNumber, email, data: gatewayData });
    return data;
};

// Cloudinary photos ko chhota + WebP/AVIF mein serve karo (original photo 3-5 MB ki hoti hai)
export const optImg = (url, width = 600) => {
    if (!url || typeof url !== "string") return url;
    if (!url.includes("res.cloudinary.com") || !url.includes("/image/upload/")) return url;
    return url.replace("/image/upload/", `/image/upload/f_auto,q_auto,w_${width},c_limit/`);
};

export const formatINR = (n) =>
    new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
